export default __webpack_public_path__ + "static/national-metric-desktop-3267895d2fd9bd72487518a74b7081aa.svg";